import { Fragment } from 'react'
import { Link } from 'react-router-dom'

import {
  UiBreadcrumb,
  UiBreadcrumbItem,
  UiBreadcrumbLink,
  UiBreadcrumbList,
  UiBreadcrumbPage,
  UiBreadcrumbSeparator,
} from '@/ui/UiBreadcrumb'

export type BreadcrumbItem = {
  label: string
  to?: string
}

export type MultisigBreadcrumbItem = BreadcrumbItem
export type GovernanceBreadcrumbItem = BreadcrumbItem

export function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  if (items.length === 0) return null

  return (
    <UiBreadcrumb>
      <UiBreadcrumbList>
        {items.map((item, index) => {
          const isLast = index === items.length - 1

          return (
            <Fragment key={`${item.label}-${item.to ?? 'page'}-${index}`}>
              <UiBreadcrumbItem>
                {(() => {
                  if (isLast || !item.to) {
                    return <UiBreadcrumbPage>{item.label}</UiBreadcrumbPage>
                  }

                  return (
                    <UiBreadcrumbLink asChild>
                      <Link to={item.to}>{item.label}</Link>
                    </UiBreadcrumbLink>
                  )
                })()}
              </UiBreadcrumbItem>

              {!isLast && <UiBreadcrumbSeparator />}
            </Fragment>
          )
        })}
      </UiBreadcrumbList>
    </UiBreadcrumb>
  )
}
